import awsRumCustomEvents from '../../consts/aws/awsRumCustomEvents';
import {LOADER_TYPES} from '../../consts/loader/loaderTypes';
import {CODENTIFY_REGEX} from '../../consts/regexValues';
import QUERY_PARAMS from '../../consts/route/queryParams';
import QUERY_PARAM_VALUES from '../../consts/route/queryParamValues';
import {setCurrentFlow} from '../../state/slice/monitoring';
import {setInitialConnectionType, setInitialDeviceType, setQrCodentify} from '../../state/slice/session';
import {dispatch} from '../../state/store';
import urlUtils from '../../utils/urlUtils';
import loaderService from '../loader/loaderService';
import log from '../logger/log';
import storageService from '../storageService';
import {mapConnectionType, mapDeviceType, mapQrType, mapSourceType} from './initialParamsMapping';

const handleInitialParameters = () => {
    const params = urlUtils.getQueryParams();

    handleAppParameters(params);

    // Skip handling if initial setup is already completed
    if (storageService.getIsInitialSetupCompleted()) return;

    handleInitialSetupParameters(params);
};

// ────────────────────── App Parameters (start) ──────────────────────
const handleAppParameters = (params) => {
    const eventType = params.get(QUERY_PARAMS.EVENT_TYPE);
    const browserCheck = params.get(QUERY_PARAMS.BROWSER_CHECK);

    handlePushNotificationEvent(eventType);
    handleBrowserCheck(browserCheck);
};

const handlePushNotificationEvent = (eventType) => {
    // Indicate that the app was opened from a push notification and wait for message from SW
    if (eventType === QUERY_PARAM_VALUES.EVENT_TYPE_PUSH_NOTIFICATION_CLICK) {
        log.debug('initialParamsService: App opened from push notification');

        loaderService.showGlobalLoaderByType({type: LOADER_TYPES.NOTIFICATION_LOADER});
        // wait until useOnPushNotificationClick hides loader
    }
};

const handleBrowserCheck = (browserCheck) => {
    if (!browserCheck) return;

    if (browserCheck === String(false)) {
        storageService.setIsBrowserCheckDisabled();
    } else {
        storageService.removeIsBrowserCheckDisabled();
    }
};
// ────────────────────── App Parameters (end) ──────────────────────

// ────────────────────── Initial Setup Parameters (start) ──────────────────────
const handleInitialSetupParameters = (params) => {
    const connectionType = mapConnectionType(params.get(QUERY_PARAMS.CONNECTION_TYPE));
    const deviceType = mapDeviceType(params.get(QUERY_PARAMS.DEVICE_TYPE));
    const qrType = mapQrType(params.get(QUERY_PARAMS.QR_TYPE));
    const sourceType = mapSourceType(params.get(QUERY_PARAMS.SOURCE_TYPE));
    const codentify = params.get(QUERY_PARAMS.CODENTIFY);

    handleConnectionType(connectionType);
    handleDeviceType(deviceType);
    handleCodentify(codentify);

    setOnboardingFlow(sourceType, qrType);
};

const handleCodentify = (codentify) => {
    const isCodentifyValid = CODENTIFY_REGEX.test(codentify);

    if (!isCodentifyValid) {
        log.warn(`initialParamsService: Invalid codentify value: ${codentify}`);
        return;
    }

    dispatch(setQrCodentify(codentify));
};

const handleConnectionType = (connectionType) => {
    dispatch(setInitialConnectionType(connectionType));
};

const handleDeviceType = (deviceType) => {
    if (!deviceType) return;

    dispatch(setInitialDeviceType(deviceType));
};
// ────────────────────── Initial Setup Parameters (end) ──────────────────────

const setOnboardingFlow = (sourceType, qrType) => {
    dispatch(
        setCurrentFlow(awsRumCustomEvents.ONBOARDING, {
            initialSource: sourceType,
            initialType: qrType,
        })
    );
};

export default {
    handleInitialParameters,
};
